import React, { useState, useEffect } from 'react';
import './AdminPanel.css';
import AdminChats from './AdminChats';
import AdminWithdrawals from './AdminWithdrawals';
import AdminCustomers from './AdminCustomers';
import AdminDeposits from './AdminDeposits';

const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState('chats');
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check if user is authenticated (in real app, this would check admin token)
    const token = localStorage.getItem('authToken');
    const userData = localStorage.getItem('userData');
    
    if (token && userData) {
      try {
        const user = JSON.parse(userData);
        // In real app, you'd check if user has admin role
        // For now, we'll allow access if authenticated
        setIsAuthenticated(true);
      } catch (e) {
        setIsAuthenticated(false);
        // Redirect to login if not authenticated
        window.location.href = '/login';
      }
    } else {
      setIsAuthenticated(false);
      window.location.href = '/login';
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
    window.location.href = '/login';
  };

  const tabs = [
    { id: 'chats', label: 'Chats', icon: '💬' },
    { id: 'deposits', label: 'Deposits', icon: '💳' },
    { id: 'withdrawals', label: 'Withdrawals', icon: '💰' },
    { id: 'customers', label: 'Customers', icon: '👥' },
  ];

  if (!isAuthenticated) {
    return (
      <div className="admin-panel-loading">
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <div className="admin-panel-standalone">
      <header className="admin-panel-header-standalone">
        <div className="admin-panel-header-content">
          <div className="admin-panel-brand">
            <h1 className="admin-panel-title">Admin Panel</h1>
            <p className="admin-panel-subtitle">FX-Pool Management System</p>
          </div>
          <div className="admin-panel-header-actions">
            <button className="admin-logout-btn" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </div>
      </header>

      <nav className="admin-panel-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`admin-panel-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <span className="admin-tab-icon">{tab.icon}</span>
            <span>{tab.label}</span>
          </button>
        ))}
      </nav>

      <main className="admin-panel-content-standalone">
        {activeTab === 'chats' && <AdminChats />}
        {activeTab === 'deposits' && <AdminDeposits />}
        {activeTab === 'customers' && <AdminCustomers />}
      </main>
    </div>
  );
};

export default AdminPanel;
